export class DefaultMap<KeyType, ValueType> extends Map<KeyType, ValueType> {
  constructor(private defaultFunction: () => ValueType) {
    super();
  }

  get(key: KeyType): ValueType {
    if (!this.has(key)) {
      this.set(key, this.defaultFunction());
    }
    return super.get(key)!;
  }
}
